import Markdown from "react-markdown";
import { Light as SyntaxHighlighter } from "react-syntax-highlighter";
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
import remarkGfm from "remark-gfm";
import MermaidDiagram from "./MermaidDiagram";

import typescript from "react-syntax-highlighter/dist/esm/languages/hljs/typescript";
import javascript from "react-syntax-highlighter/dist/esm/languages/hljs/javascript";
import java from "react-syntax-highlighter/dist/esm/languages/hljs/java";
import python from "react-syntax-highlighter/dist/esm/languages/hljs/python";

SyntaxHighlighter.registerLanguage("typescript", typescript);
SyntaxHighlighter.registerLanguage("javascript", javascript);
SyntaxHighlighter.registerLanguage("java", java);
SyntaxHighlighter.registerLanguage("python", python);

const MessageTextContainer = ({ children }) => {
  return (
    <div style={{ maxWidth: '100%', overflowX: 'auto', minWidth: 0 }}>
      <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
        pre(props) {
          return (
            <pre
              {...props}
              style={{
                maxWidth: '100%',
                overflowX: 'auto',
                margin: 0,
              }}
            />
          );
        },
        code(props) {
          const { children, className, node, ...rest } = props;
          const match = /language-(\w+)/.exec(className || "");

          // Handle Mermaid diagrams
          if (match && match[1] === "mermaid") {
            const chartContent = String(children).replace(/\n$/, "");
            console.log("Mermaid code block detected, content:", chartContent);
            return <MermaidDiagram chart={chartContent} />;
          }

          // Handle regular code with syntax highlighting
          return match ? (
            <SyntaxHighlighter
              {...rest}
              children={String(children).replace(/\n$/, "")}
              style={atomOneDark}
              language={match[1]}
              PreTag="div"
              customStyle={{
                maxWidth: '100%',
                overflowX: 'auto',
                margin: 0,
              }}
              codeTagProps={{
                style: {
                  whiteSpace: 'pre',
                  wordBreak: 'normal',
                  overflowWrap: 'normal',
                }
              }}
            />
          ) : (
            <code
              {...rest}
              className={className}
              style={{
                maxWidth: '100%',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}
            >
              {children}
            </code>
          );
        },
        a(props) {
          return (
            <a {...props} target="_blank" rel="noopener noreferrer">
              {props.children}
            </a>
          );
        },
      }}
    >
      {children}
    </Markdown>
    </div>
  );
};

export default MessageTextContainer;
